module.exports = "/images/icon-whatsapp.svg?613e69f5fa1981d9b13e690a2b62d0da";